export function truncate(str: string, n: number) {
  return str.length > n ? str.slice(0, n - 1) + "&hellip;" : str;
}

export function getLabelKV(str: string): string {
  if (str === "") return "";
  if (funderLabelMap[str]) return funderLabelMap[str];
  // console.error("No mapped value for", str);
  return str;
}

export const fundersSpecifiers = [
  { id: "ANGEL", value: "Angel" },
  { id: "ANGEL_SYNDICATE", value: "Angel Syndicate" },
  { id: "INVESTMENT_MANAGEMENT_FIRM", value: "Investment Management Firm" },
  { id: "BANK", value: "Bank" },
  { id: "CORPORATE", value: "Corporate" },
  { id: "CVC", value: "Corporate Venture Capital (CVC)" },
  { id: "DFI", value: "Development Finance Institution (DFI)" },
  { id: "FAMILY_OFFICE", value: "Family Office" },
  { id: "GOVERNMENT", value: "Government" },
  { id: "HEDGE_FUND", value: "Hedge Fund" },
  { id: "IMPACT_INVESTOR", value: "Impact Investor" },
  { id: "PITCH_COMPETITION", value: "Pitch Competition & Hackathons" },
  { id: "PRIVATE_EQUITY_FIRM", value: "Private Equity Firm" },
  { id: "PRIVATE_EQUITY", value: "Private Equity" },
  { id: "VC", value: "Venture Capital Firm" },
  { id: "PENSION_FUND", value: "Pension Fund" },
  { id: "SWF", value: "Sovereign Wealth Fund (SWF)" },
  { id: "OTHER", value: "Other" },
];

// Create a lookup map once
const funderLabelMap: Record<string, string> = fundersSpecifiers.reduce(
  (acc, curr) => {
    acc[curr.id] = curr.value;
    return acc;
  },
  {} as Record<string, string>,
);

export const getOrgTypeMap = (type: string) => {
  switch (type) {
    case "startup":
      return "Startup";
    case "esos":
      return "ESOs";
    case "investor":
      return "Investors";
    default:
      return type;
  }
};

export const getTypeByPathname = (pathname: string) => {
  switch (pathname) {
    case "/companies":
      return "startup";
    case "/esos":
      return "esos";
    case "/investors":
      return "investor";
  }
};

export const getOperatingStatusByCode = (code: string) => {
  switch (code?.toLowerCase()) {
    case "y":
    case "yes":
      return "Operating";
    case "n":
    case "no":
      return "Shut down";
    default:
      return "Under review";
  }
};

export const isBriterBridgesUser = (email?: string): boolean => {
  // Normalize once, handle undefined with nullish coalescing
  const normalized = email?.toLowerCase().trim() ?? "";

  // Easy to maintain/extend domain list
  const allowedDomains = ["@briterbridges.com", "@briter.co"];

  return allowedDomains.some((domain) => normalized.endsWith(domain));
};
